module.exports = __webpack_public_path__ + "img/cooperate_6.00bfbc50.png";